import React, { use } from 'react'

import { ContactModal } from '@Domains/Contact/Modal'
import { PageType } from '@Generated/graphql'
import { CMSModalContent } from '@Globals/CMS/Modal/Content'
import { CMSModalContext } from '@Globals/CMS/Modal/Context'

export const CMSModalRenderer = () => {
  const [state, , close] = use(CMSModalContext)
  if (!state?.id || !state?.type) {
    return null
  }

  if (state.type === PageType.Modal && state.id === 'contact-us') {
    return (
      <ContactModal defaultOpen onClose={close} />
    )
  }

  return (
    <CMSModalContent
      id={state.id}
      onClose={close}
      presentation={state.presentation}
      type={state.type}
    />
  )
}
